<template>
  <div
    class="select-none transform transition-all duration-600 h-10 text-white rounded-md flex items-center text-sm">
      <slot name="commons" />
      <div class="hidden md:block">
        <slot name="desktop" />
      </div>
      <div
        ref="moreSection"
        v-outside:click="{ exclude: ['moreSection'], handler: closeMore }"
        class="relative">
        <span class="flex group" :class="{ disabled: disabled }">
          <base-button class="main-button md:pl-6 md:pr-2 pl-4 pr-1" :class="{ '!rounded-r-none': baseDropDownVisible, 'md:!pr-6 !pr-4': !baseDropDownVisible }"
           :size="size" :mode="mode" :loading="loading" :disabled="disabled" @click="mainClick" :icon="icon" :text="name" />
          <base-button v-if="baseDropDownVisible"  class="more-button relative !rounded-l-none md:px-2.5 px-2"
            :mode="mode" :size="size" group @click="toggleMore">
            <base-icon
              :class="arrowIconClass"
              class="transition-transform duration-300"
              name="chevronup"/>
          </base-button>
        </span>
        <base-drop-down v-if="baseDropDownVisible" 
          autoClose 
          :isOpen="more" 
          position="bottom-right" 
          :customClass="setCustomClass"
          @toggle="closeMore" >
          <slot name="more" />
        </base-drop-down>
      </div>
    </div>
</template>

<script>
import { i18n } from '@/i18n'
export default {
  name: 'base-table-select-more-actions-form',
  props: {
    name: {
      type: [String],
      default: i18n.tc('app.actions', 2)
    },
    icon: {
      type: [String]
    },
    baseDropDownVisible: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return ['primary', 'staticprimary', 'secondary', 'primary-phantom', 'staticprimary-phantom', 'secondary-phantom', 'secondary-phantom-blue', 'primary-line', 'tools', 'core'].indexOf(value) !== -1
      }
    },
    size: {
      type: String,
      default: 'md',
      validator: function (value) {
        return ['xs', 'sm', 'md'].indexOf(value) !== -1
      }
    },
    dir: {
      type: String,
      default: 'up',
      validator: function (value) {
        return ['up', 'down'].indexOf(value) !== -1
      }
    },
    customClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  data: function () {
    return {
      more: false
    }
  },
  computed: {
    setCustomClass () {
      return [{
        'w-72 p-1 bottom-10': this.dir === 'up',
        'w-72 p-1 ': this.dir === 'down',
      }, this.customClass]
    },
    arrowIconClass () {
      return { 'rotate-180': (this.dir === 'up' && this.more) || (this.dir === 'down' && !this.more) }
    }
  },
  methods: {
    mainClick: function () {
      this.$emit('mainclick')
    },
    toggleMore: function () {
      this.more = !this.more
    },
    closeMore: function () {
      this.more = false
    }
  }
}
</script>

<style lang="scss" scoped>
.more-button::before {
  content: "";
  position: absolute;
  display: block;
  width: 1px;
  top: 5px;
  bottom: 5px;
  left: 0;
  background: currentColor;
}

.group:hover .more-button::before,
.group:active .more-button::before,
.group:has(>:hover) .more-button::before,
.group:has(>:active) .more-button::before {
  top: 0;
  bottom: 0;
}

.group:has(>:active:not(.disabled)) {
  transform: scale(0.96);
}

.main-button:active:not(.disabled),
.more-button:active:not(.disabled) {
  transform: none;
}
</style>
